import { render, staticRenderFns } from "./JobOrderServices.vue?vue&type=template&id=2a49c6bd"
import script from "./JobOrderServices.vue?vue&type=script&lang=js"
export * from "./JobOrderServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports